import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  transition: 0.25s;
  z-index: 99998;
  display: flex;
  justify-content: center;
  align-items: center;
`;
